import ApiService from "@/core/services/ApiService";
import { Actions, APIEndpoints } from "@/store/enums/StoreEnums";
import { Module, Action, VuexModule, config } from "vuex-module-decorators";

config.rawError = true;

@Module
export default class ExpertiseModule extends VuexModule {
  @Action
  [Actions.GET_ALL_EXPERTISES]() {
    ApiService.setHeader();
    return new Promise((resolve, reject) => {
      ApiService.get(`/${APIEndpoints.EXPERTISE}`)
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
}
